import React from 'react';
import Footer from './components/Footer';
export default function PageNotFound() {
  return (
    <div className='flex-1 flex w-full flex-col'>
      <div className='w-full flex-1 addnavpadding px-[12px] py-[48px]'>
        404 - Page Not Found
      </div>
      <Footer/>
    </div>
  );
}

